/**
 * @generated SignedSource<<71ace1661fdde574a269f7ae2b608a42>>
 * @relayHash 9e0fefee5d15f269f270240efc59f11c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 74aa4fbafb88fa6effcd250ecc683e8d28fc45847ecdd473f90dfc7011124e68

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavPlansQuery } from './HorizontalNavPlansQuery.graphql';

const node: PreloadableConcreteRequest<HorizontalNavPlansQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "74aa4fbafb88fa6effcd250ecc683e8d28fc45847ecdd473f90dfc7011124e68",
    "metadata": {},
    "name": "HorizontalNavPlansQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
